import Vue from 'vue'
import Widget from './Widget.vue'
import 'document-register-element/build/document-register-element'
import vueCustomElement from 'vue-custom-element'
import i18n from './i18n'
import VueI18n from 'vue-i18n'
import './assets/tailwind.css'


Vue.use(VueI18n)
Vue.use(vueCustomElement)
Widget.i18n = i18n
Vue.customElement('your-fred', Widget)